import { Link } from "react-router-dom";

export function Cancel() {
  return (
    <section className="mx-auto max-w-xl px-6 py-20 text-center">
      <h1 className="font-serif text-4xl tracking-tight">Checkout canceled</h1>
      <p className="mt-3 text-neutral-600">
        No charge was made. Your photo is safely stored for a few days if you'd like to try again.
      </p>
      <Link
        to="/upload"
        className="mt-8 inline-flex rounded-full bg-black text-white px-6 py-2.5 text-sm font-medium hover:bg-neutral-800 transition"
      >
        Back to upload
      </Link>
    </section>
  );
}
